'use client';

import { useTranslations } from 'next-intl';
import { Paperclip, X } from 'lucide-react';
import type { PendingAttachmentDraft } from '../types/attachment';

type AttachmentPendingChipsProps = {
  drafts: PendingAttachmentDraft[];
  onChange: (drafts: PendingAttachmentDraft[]) => void;
  disabled?: boolean;
};

export function AttachmentPendingChips({ drafts, onChange, disabled = false }: AttachmentPendingChipsProps) {
  const t = useTranslations('components.attachment');

  if (drafts.length === 0) return null;

  const removeAt = (index: number) => {
    onChange(drafts.filter((_, i) => i !== index));
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {drafts.map((draft, index) => (
        <span
          key={draft.key}
          className="inline-flex items-center gap-1 rounded-full border border-base-300 bg-base-100 py-0.5 pl-2 pr-1 text-xs"
          title={draft.originalName}
        >
          <Paperclip className="h-3 w-3 text-[var(--color-fg-muted)]" />
          <span className="max-w-[140px] truncate">{draft.originalName}</span>
          <button
            type="button"
            className="rounded-full p-0.5 text-[var(--color-fg-muted)] hover:bg-base-200 hover:text-error disabled:opacity-40 disabled:hover:bg-transparent"
            onClick={() => removeAt(index)}
            disabled={disabled}
            aria-label={t('removeItem', { name: draft.originalName })}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
  );
}
